import { put, takeEvery } from 'redux-saga/effects';

import { VehicleAction } from '../actions';
import { VehicleConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [
      VehicleConstant.CREATE_VEHICLE_SUCCESS,
      VehicleConstant.EDIT_VEHICLE_SUCCESS,
    ],
    createOrEditVehicleSuccess,
  );
  yield takeEvery(VehicleConstant.DELETE_VEHICLE_SUCCESS, deleteVehicleSuccess);
  yield takeEvery(VehicleConstant.GET_VEHICLES_SUCCESS, getVehiclesSuccess);
  yield takeEvery(VehicleConstant.GET_VEHICLE_SUCCESS, getVehicleSuccess);
}

function* createOrEditVehicleSuccess() {
  yield put(VehicleAction.setVehicle({}));
}

function* deleteVehicleSuccess() {
  yield put(VehicleAction.getVehicles());
}

function* getVehiclesSuccess(action) {
  yield put(VehicleAction.setVehicles(action?.payload));
}

function* getVehicleSuccess(action) {
  yield put(VehicleAction.setVehicle(action?.payload));
}
